import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationService } from '../application.service';
import { HeaderService, Header } from '../../common/header/header.service';
import { FooterService, Footer } from '../../common/footer/footer.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { TokenService } from '../../token/token.service';
import { Application, States } from '../application';
import { CounterOffer } from '../../risk/risk';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';

declare var $;

@Component({
  selector: 'zest-counter-offer',
  templateUrl: './counter-offer.component.html',
  styleUrls: ['./counter-offer.component.scss']
})
export class CounterOfferComponent implements OnInit, OnDestroy {

  public application: Application;
  public processingApprove = false;
  public processingReject = false;
  public counterOffer: CounterOffer;
  public firstName = '';
  public states: States;

  constructor(
    private router: Router,
    private headerService: HeaderService,
    private footerService: FooterService,
    private loaderService: LoaderService,
    private applicationService: ApplicationService,
    private tokenService: TokenService,
    private awsTrackingService: AwsTrackingService
  ) { }

  ngOnInit() {
    this.application = this.applicationService.getApplication();
    this.states = this.applicationService.getPreapproveStates();
    if (this.states.loan.IsTenureChanged) {
      this.headerService.ShowHeaderSource.next(new Header(1, true, 50, true, 'Profile', false));
    } else {
      this.headerService.ShowHeaderSource.next(new Header(1, false, 0, false, 'Profile', false));
    }
    this.footerService.ShowFooterSource.next(new Footer(false, false, false, false, false, true));
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    $('.page-container').css('max-width', '500px');
    this.firstName = this.tokenService.getCustomerDetails().name;
    this.getCounterOffer();
  }
  ngOnDestroy() {
    $('.page-container').css('max-width', 'unset');
  }
  getCounterOffer() {
    this.applicationService.getCounterOffer(this.application.ApplicationId).subscribe(response => {
      this.counterOffer = response;
      const risk = this.states.loan.IsLoanAmountChanged ? 'R2' : 'R1';
      this.awsTrackingService.gtmPageLoadEvent(`${risk}-Counter-Offer-Loaded`);
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    }, error => {
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    });
  }
  proceed() {
    this.approveCounterOffer(true);
  }
  cancel() {
    this.approveCounterOffer(false);
  }
  showModal() {
    setTimeout(fn => { $('#backToMerchant').modal('open'); }, 0);
  }
  closeModal() {
    setTimeout(fn => { $('#backToMerchant').modal('close'); }, 0);
  }
  approveCounterOffer(decision: boolean) {
    if (decision) {
      this.processingApprove = true;
    } else {
      this.processingReject = true;
    }
    if (this.states.loan.IsLoanAmountChanged) {
      this.applicationService.approveLoanAmountChangeCounterOffer(this.application.ApplicationId, decision).subscribe(response => {
        this.counterOfferSuccessHandler(decision);
      }, error => {
        this.counterOfferErrorHandler(decision);
      });
    } else {
      this.applicationService.approveCounterOffer(this.application.ApplicationId, decision).subscribe(response => {
        this.counterOfferSuccessHandler(decision);
      }, error => {
        this.counterOfferErrorHandler(decision);
      });
    }
  }
  counterOfferSuccessHandler(decision: boolean) {
    const risk = this.states.loan.IsLoanAmountChanged ? 'R2' : 'R1';
    if (decision) {
      this.awsTrackingService.gtmTriggerEvent(`${risk}-Counter-Offer-Accepted`);
      this.applicationService.getOrderDetails(this.application.ApplicationId).subscribe(response => {
        this.applicationService.saveApplication(response);
        this.applicationService.goToNextRoute(this.router.url);
      });
    } else {
      this.awsTrackingService.gtmTriggerEvent(`${risk}-Counter-Offer-Rejected`);
      this.tokenService.cancel(this.application);
    }
  }
  counterOfferErrorHandler(decision: boolean) {
    if (decision) {
      this.processingApprove = false;
    } else {
      this.processingReject = false;
    }
  }

}
